import * as React from 'react';
import { getRandomValue } from '../functions/numbers.js';
export const useId = () => {
  let uniqueValue = useUniqueValue();
  return React.useMemo(() => `iui-${uniqueValue}`, [uniqueValue]);
};
let _React = React;
let useUniqueValue =
  _React.useId ?? (() => React.useMemo(() => getRandomValue(10), []));
